import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import PropTypes from 'prop-types'
import * as AppActions from '../../actions/app'
import * as UserActions from '../../actions/user'

import { routes } from '../../constants'

/**
 * Login Container
 */
class LoginCallback extends PureComponent {
    static propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
    }

    static defaultProps = {
        //error: null,
    }


    /**
     * Render container
     */
    render() {
        const { isAuthenticated } = this.props

        if (isAuthenticated) {
            return <Redirect to={routes.ROOT} />
        }
    }
}

const mapStateToProps = ({
    user: {
        session: { isAuthenticated },
    },
}) => ({
    isAuthenticated,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...AppActions,
            ...UserActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(LoginCallback)
